import React, { useEffect, useState } from 'react'

import { Heading, Box } from '@chakra-ui/react'

import CheckboxList from "../../components/ui/CheckboxList";

import "./MqttFilterAction.scss";

const lsKey = "ltFilterAction"

function MqttFilterAction(props) {

  const [allSelected, setAllSelected] = useState(false)

  useEffect(() => {
    const f = "MqttFilterAction::useEffect"
    let lsstr = localStorage.getItem(lsKey);
    console.log(f, lsstr)
    let ls;
    if (lsstr) { // if local storage already exists
      ls = JSON.parse(lsstr)
      for (let type in global.aaa.actionIds) {  // copy selected values into global records
        const selected = (ls[type]) ? ls[type].selected : true;
        global.aaa.actionIds[type].selected = selected
      }
    } else {
      ls = {};
      for (let type in global.aaa.actionIds) {
        console.log(f, 'initialize localStorage ', type)
        if (!ls[type]) ls[type] = {}
        ls[type].selected = true
        global.aaa.actionIds[type].selected = true
      }
      localStorage.setItem(lsKey, JSON.stringify(ls))
    }
    setAllSelected(global.aaa.actionIds.all.selected)
    console.log(f, 'exit', ls)
//}, [global.aaa.mqttConnected])
  }, [])

  const onChangeH = event => {
    console.log('MqttFilterAction::onChangeH',event.target.checked)
    global.aaa.actionIds[event.target.id]['selected'] = event.target.checked

    if (event.target.id === 'all') {
      setAllSelected(event.target.checked)
    }
    let ls = JSON.parse(localStorage.getItem(lsKey))
    if (!ls[event.target.id]) {
      ls[event.target.id] = {}
    }
    ls[event.target.id]['selected'] = event.target.checked
    localStorage.setItem(lsKey, JSON.stringify(ls))

    props.onChangeH(event);
  }

  return (
    <Box className={`mqtt-filter-action filters ${props.show ? "show" : ""}`}>
      <Heading as="h3">Action</Heading>
      <Box className={`select mqtt-action-bg ${allSelected ? "all-selected" : ""}`}>
        <CheckboxList list={(global.aaa.actionIds) ? global.aaa.actionIds : {}} onChangeH={onChangeH} />
      </Box>
    </Box>
  );
}

export default MqttFilterAction
